import { SCRIBENOTE_FLASK } from "../constants";

export const openInNewTab = (url) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");

  if (newWindow) {
    newWindow.opener = null;
    newWindow.focus();
  }
};

export const truncate = (str, n) => {
  return str?.length > n ? str.substr(0, n - 1) + "..." : str;
};

export const evictNoteCache = (cache) => {
  cache.evict({
    id: "ROOT_QUERY",
    fieldName: "inboxTabCount",
  });
  cache.evict({
    id: "ROOT_QUERY",
    fieldName: "teamUserNoteCounts",
  });
  cache.evict({ id: "ROOT_QUERY", fieldName: "inboxNotes" });
};

export const toTitleCase = (str) => {
  return str
    .replaceAll("-", " ")
    .replaceAll("_", " ")
    .replace(
      /\w\S*/g,
      (text) =>
        text.charAt(0).toUpperCase() +
        text.substring(1).toLowerCase(),
    );
};

/**
 * A temporary measure for determining where to send requests app wide
 * based on how a feature flag (use-porter-migration-flag) sets the
 * SCRIBENOTE_API_HOST localstorage item
 *
 *
 * @returns {string} The URL of the Flask server to use
 */
export const getTempScribenoteFlask = () => {
  // const flask_host =
  //   localStorage.getItem("SCRIBENOTE_API_HOST") || SCRIBENOTE_FLASK;

  // return flask_host;
  // Not used for now
  return SCRIBENOTE_FLASK;
};

export const isMCloudIFrame = () => {
  return (
    window.location.search.includes("embedded") ||
    window.location.search.includes("mcloud_embedded")
  );
};
export const isMCloudEmbedded = () => {
  return !!localStorage.getItem("mcloud_embedded");
};
export const setMCloudEmbedded = () => {
  localStorage.setItem("mcloud_embedded", true);
};
